import { useCallback, useEffect } from 'react'

export function isInView(current, ratio = 1) {
  if (!current) return false
  const rect = current.getBoundingClientRect()

  const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)
  const visibleRatio = visibleHeight / rect.height

  return visibleRatio >= ratio
}

export function useObserver(ref, callback, ratio = 1, threshold = 1) {
  useEffect(() => {
    if (!ref?.current) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.intersectionRatio === ratio) {
          callback?.({ fromInterceptCheck: false })
        }
      },
      { threshold }
    )

    observer.observe(ref.current)

    return () => observer.disconnect()
  }, [ref, callback, ratio, threshold])

  const interceptCheck = useCallback(() => {
    if (ref?.current && isInView(ref.current, ratio)) {
      callback?.({ fromInterceptCheck: true })
    }
  }, [ref, callback, ratio])

  return { interceptCheck }
}